import { useMutation } from "@tanstack/react-query";
import { CreatedThread } from "api/schema/insights/threads";
import { AxiosError } from "axios";
import { usePublicApiService } from "contexts/PublicApiServiceProvider";

export const useCreateThread = ({ companyId }: { companyId: string }) => {
  const publicApi = usePublicApiService();
  return useMutation<CreatedThread, AxiosError>({
    mutationKey: ["createThread", { companyId }],
    mutationFn: () =>
      publicApi.createInsightsThread({
        companyId,
        reportType: "spendAnalysis",
        reportOutput: "suppliers",
        reportId: "latest",
      }),
  });
};
